<wsb-modal class="custom-modal-width" cancelButtonEnable="true" (close)="activeModal.close(dontShowAgainCheck.value)"
  (dismiss)="activeModal.dismiss(dontShowAgainCheck.value)" title="{{ 'privacy_setting_modal_title' | translate }}"
  (primary)="checkPwd()" primaryButtonText="common_save" cancelButtonText="common_close"
  [primaryDisabled]="!checkObfuscationChange()">
  <div body>
    <div class="mb-5" [innerHtml]="'privacy_setting_modal_alert' | translate"></div>

    <div class="page__form-wrap">
      <div class="form-group row">
        <label for="message-obfuscation-type" class="col-sm-4" translate>privacy_mess_archive_authorization</label>
        <div class="col-sm-8">
          <wsb-ui-checkbox #messageObfuscationCheck [(checked)]="messageObfuscationTypeCheck"
            (checkedChange)="messageObfuscationTypeChange()" class="ms-3 pt-1"
            id="message-obfuscation-type"></wsb-ui-checkbox>
        </div>
      </div>
    </div>

    <!-- <div class="d-flex align-items-center">
      <label class="col-5 ps-0" translate for="checkPassword">privacy_modal_enter_password</label>
      <div class="col-5 ms-3">
        <input [type]="'password'" class="form-control" [formControl]="checkPassword" id="checkPassword" />
      </div>
    </div> -->
    <div class="dont-show-again form-check">
      <!-- <wsb-ui-checkbox #dontShowAgainCheckbox [(checked)]="dontShowAgainCheck" class="ms-3 pt-1" id="message-obfuscation-type"></wsb-ui-checkbox> -->
      <input class="dont-show-again-checkbox form-check-input" type="checkbox" [formControl]="dontShowAgainCheck"
        id="message-obfuscation-type" />
      <label for="message-obfuscation-type" class="form-check-label" translate>common_dont_show_again</label>
    </div>
  </div>
</wsb-modal>